import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  Skeleton,
} from '@mui/material';
import { useGetCodesQuery } from 'src/api/codes/getCodes';
import { useGlobalFiltersStore } from 'src/store/globalFilters.store';

export const CodeFilter = () => {
  const { setLanguageCode } = useGlobalFiltersStore();
  const { data: codes = [], isLoading } = useGetCodesQuery();

  const handleChange = (event: SelectChangeEvent) => {
    setLanguageCode(event.target.value);
  };

  if (isLoading) {
    return <Skeleton variant='rectangular' width='100%' height={55} />;
  }

  return (
    <FormControl sx={{ width: '100%' }}>
      <InputLabel id='languageCode'>Filter by sport</InputLabel>
      <Select
        label='Filter by sport'
        defaultValue=''
        onChange={handleChange}
        sx={{ width: '100%' }}
      >
        <MenuItem value=''>All</MenuItem>
        {codes.map((code) => (
          <MenuItem key={code.id} value={code.code}>
            {code.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
